import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { AutoSizer } from 'react-virtualized';
import { EmptyState, Flex, Text } from 'core/components';
import storeLoader from 'app/stores/storeLoader';
import AlarmTimeline from 'app/views/synthetics/components/alarmTimeline/AlarmTimeline';
import TestResultsTable from 'app/views/synthetics/components/testResults/TestResultsTable';
import LoadingPanel from 'app/views/synthetics/components/testResults/panels/LoadingPanel';
import ToolResultCard from 'app/views/core/kaizen/components/ToolResultCard';
import LoadingSkeleton from 'app/views/core/journeys/LoadingSkeleton';
import AggregationTag from 'app/views/synthetics/components/AggregationTag';

@storeLoader('$syn.agents', '$syn.tests')
@observer
export default class SyntheticsTestResultsToolResult extends Component {
  state = {};

  static getDerivedStateFromProps(props, state) {
    const { $syn, loading, tool } = props;
    const {
      query_object,
      raw_result: { timestamps, results, alarms, aggregation }
    } = tool;
    const { test_id } = query_object;

    if (!loading && !state.testModel) {
      const testModel = $syn.getTest(test_id);

      if (testModel) {
        testModel.results.loadResults({ timestamps, results, alarms, aggregation });
        return { testModel, timestamps };
      }
    }

    return null;
  }

  onChangeResultTimeMs = (resultTimeMs) => {
    const { testModel } = this.state;
    testModel.results.onChangeResultTimeMs(resultTimeMs);
  };

  get title() {
    const { tool } = this.props;
    const { testModel } = this.state;
    return (
      <Flex alignItems="flex-start" gap={1} mr={1}>
        <Text>{tool?.title || 'Test Results'}</Text>
        <AggregationTag testResults={testModel.results} minWidth="fit-content" />
      </Flex>
    );
  }

  render() {
    const { tool = {}, onCloseToolResult, isInlineMode, loading } = this.props;
    const { testModel } = this.state;

    if (loading) {
      return <LoadingSkeleton />;
    }

    if (!testModel) {
      return <EmptyState m={2} icon="disable" title="Test Not Found" />;
    }

    return (
      <ToolResultCard
        tool={tool}
        onCloseToolResult={onCloseToolResult}
        isInlineMode={isInlineMode}
        title={this.title}
        minHeight={750}
        px={2}
      >
        <AutoSizer disableHeight>
          {({ width }) => (
            <AlarmTimeline
              {...testModel.results.timelineBounds}
              width={width}
              data={testModel.results.healthTimeline}
              testResults={testModel.results}
              onSelect={this.onChangeResultTimeMs}
            />
          )}
        </AutoSizer>
        <LoadingPanel
          test={testModel}
          testResults={testModel.results}
          loading={testModel.results.loading && !testModel.results.hasResults}
          empty={testModel.results.healthTimeline.length === 0 || !testModel.results.hasResults}
        >
          <TestResultsTable
            test={testModel}
            results={testModel.results.results}
            agentTaskConfig={testModel.results.agentTaskConfig}
            resultTimeMs={testModel.results.resultTimeMs}
            allowAgentDetails={testModel.results.displayOptions.allowAgentDetails}
          >
            {(resultsTable) => (
              <>
                {resultsTable.footer}
                {resultsTable.allResults}
              </>
            )}
          </TestResultsTable>
        </LoadingPanel>
      </ToolResultCard>
    );
  }
}
